import React from "react";
import {useTranslation} from "react-i18next";
import {clsx} from "clsx";
import {InfoMessageType, setInfoMessage} from "components/InfoMessage";
import LoadingIcon from "components/Icons/LoadingIcon";

const AccessTicketDriversAssignUserButton = (props: {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
    secondRowChildren?: React.ReactNode | React.ReactNode[];
    frontIcon: React.ReactNode;
    backIcon: React.ReactNode;
    onClick: any;
    isDisableDriver?: boolean;
    isInvited?: boolean;
    isLoading?: boolean;
}) => {
    const {t} = useTranslation();

    const onClickDisableDriver = () => {
        setInfoMessage(t("Cannot add adult user to a child ticket"), InfoMessageType.WARNING);
    };

    return (
        <button
            className={clsx(
                "AccessTicketDriversAssignUserButton w-full rounded-[10px] bg-white hover:outline-2 hover:outline-black hover:shadow-hover focus:bg-gray-200 active:bg-gray-200  text-xs md:text-base text-black shadow-card",
                props.className,
                props.isDisableDriver && "opacity-40 cursor-not-allowed"
            )}
            type={"button"}
            onClick={props.isDisableDriver ? onClickDisableDriver : props.onClick}
        >
            <div className={"flex items-center justify-between"}>
                <div
                    className={
                        "frontIcon box-content py-[20px] md:py-[30px] pl-[11px] md:pl-[16px] pr-[13px] md:pr-[24px] stroke-2 flex items-center justify-center"
                    }
                >
                    {props.frontIcon}
                </div>
                {props.children}
                {props.isLoading && <LoadingIcon className={"stroke-2 size-4"} />}
                {!props.isInvited && (
                    <div className={"isInvited size-5 md:size-8 box-content px-[17px] md:px-[16px] stroke-2 flex items-center justify-center"}>
                        {props.backIcon}
                    </div>
                )}
            </div>
            {props.secondRowChildren && <div className={"secondRowChildren border-t mx-3 py-2 text-left text-xxs md:text-xs"}>{props.secondRowChildren}</div>}
        </button>
    );
};

export default AccessTicketDriversAssignUserButton;
